import lottie from 'lottie-web'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

// to load lottie add class js-load-lottie,
// attributes:   data-json, data-loop, data-autoplay, data-play-on-hover
// to play lottie when scrolled in screen add class:  js-play-lottie-on-scrolled
//
// <div class="js-load-lottie lottie" 
//     data-json="<?= $lottie['url'] ?>" 
//     data-autoplay="true" 
//     data-loop="false" // for true not add attribute 
//     data-name="aniamtion-name" 
//     >
//   </div>


export function loadElementLottie(elements) {
  elements.each(function () {
    if (! this.classList.contains('loaded')){
      this.classList.add('loaded')
      let json = this.getAttribute('data-json')
      let loop = this.getAttribute('data-loop')
      if (!loop) loop = true
      let autoplay = this.getAttribute('data-autoplay')
      if (!autoplay) autoplay = false
      let playOnHover = this.getAttribute('data-play-on-hover')
      if (!playOnHover) playOnHover = false
      let startFrame = this.getAttribute('data-start-frame')
      if (!startFrame) startFrame = 0
      let totalFrames = this.getAttribute('data-total-frames')
      if (!totalFrames) totalFrames = 200
      let name = this.getAttribute('data-name')
      let speed = this.getAttribute('data-json-speed')
      if (!speed) speed = 1
      let delay = this.getAttribute('data-delay')
      if (!delay) delay = 0

      let animation = lottie.loadAnimation({
        container: this,
        animType: 'svg',
        loop: loop,
        autoplay: autoplay,
        path: json,
        name: name,
        //initialSegment: [startFrame, totalFrames],
      });
      if (speed !== 1) animation.setSpeed(speed)

      if (delay){
        setTimeout(function(){
          animation.goToAndStop(0, true, $(this).data('name'))
          animation.play()
        }, parseInt(delay))
      }

      // go to start, to later can lottie.play
      // if (!playOnHover) {
      //   animation.onComplete = function () {
      //     animation.goToAndStop(0, true)
      //   }
      // }

      // play on hover


      if (playOnHover) {
        
        this.addEventListener("mouseenter", () => {
          animation.setDirection(1);
          animation.play();
          // animation.addEventListener("complete", function(anim){
          //     animation.goToAndStop(0);
          // });
        });
        this.addEventListener("mouseleave", () => {
          animation.setDirection(-1);
          animation.play();
        });
      }

    }
  })

  setTimeout(function(){
    ScrollTrigger.refresh()
  }, 200)
}


export function playLottie($el){
  lottie.goToAndStop(0, true, $el.data('name'))
  lottie.play($el.data('name'))
}

export function loopPlayLottie($el){
  lottie.goToAndStop(0, true, $el.data('name'))
  lottie.play($el.data('name'))
  let interval = $el.data('lottie-interval') ? $el.data('lottie-interval') : 4000
  setInterval(()=> loopPlayLottie($el), interval)
}


// js-play-lottie-on-hover
$('body').on('mouseenter', '.js-play-lottie-on-hover', function() {
    let el = $(this).find('.lottie').data('name')
    //lottie.setDirection(1, el);
    lottie.goToAndStop(0, true, el)
    lottie.play(el);
});




window.addEventListener('load', (event) => {
  loadElementLottie($('.js-load-lottie'))
  loadLottieFilesOnScroll()
})



// Play Lottie when scrolled in screen, to use add to js-lottie class: js-play-lottie-on-scrolled
export function loadLottieFilesOnScroll () {
  document.querySelectorAll('.js-play-lottie-on-scrolled').forEach(function (el) {
    let loadOffset = el.getAttribute('data-load-offset') ? el.getAttribute('data-load-offset') : '100'
    ScrollTrigger.create({
      trigger: el,
      start: "top bottom-=" + loadOffset + "px", // el top, screen bottom
      once: true,
      onEnter: () => {
        let loopPlay = el.getAttribute('data-loop-play') ? el.getAttribute('data-loop-play') : false
        if (loopPlay) {
          loopPlayLottie($(el))
        } else {
          playLottie($(el))
        }
        el.classList.add('played')
      }
    });
  })
}
